module.exports = __webpack_public_path__ + "static/img/zhifubao.cbb909a.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/zhifubao.png
// module id = /vSY
// module chunks = 4